import { render } from "./MasterAlatBerat.vue?vue&type=template&id=05b3e835"
import script from "./MasterAlatBerat.vue?vue&type=script&lang=js"
export * from "./MasterAlatBerat.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__